import { AxiosError, AxiosResponse } from 'axios';
import Core from '../core';

async function getActionRequiredDetail(
  eventName: string,
  userId: number,
  fromDate: string,
  toDate: string,
  locale: any,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `v1/actionRequired/leave/forme?event=${eventName}&userId=${userId}&from_date=${fromDate}&to_date=${toDate}&locale=${locale}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getLeaveEncashment(
  eventName: string,
  userId: number,
  fromDate: string,
  toDate: string,
  locale: any,
) {
  const api = Core.getInstance().api();
  const data = await api.post(
    `v2/actionRequired/leaveEncash/forme?event=${eventName}&userId=${userId}&from_date=${fromDate}&to_date=${toDate}&locale=${locale}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}


async function getLeaveHistory(employeID: number, companyID: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `v1/actionRequired/leaveHistory?empId=${employeID}&companyId=${companyID}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getEmpTicketHistory(employeID: number, companyID: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `v1/actionRequired/ticketHistory?empId=${employeID}&companyId=${companyID}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getLeaveInsight(
  departmentId: number,
  fromDate: any,
  toDate: any,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/actionRequired/leaveInsight?departmentId=${departmentId}&fromDate=${fromDate}&toDate=${toDate}
    `,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getStepActions(currentStep: any, workflowID: any) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/actionRequired/getStepActions?current_step=${currentStep}&workflow_id=${workflowID}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function userCanActOnStep(
  userId: any,
  compId: any,
  stepId: any,
  empId: any,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/actionRequired/actor/canAct?userId=${userId}&companyId=${compId}&&stepId=${stepId}&empId=${empId}
    `,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function finalActionSubmitActionRequired(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.post(`/v1/machine/instance/action`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllPromotionsActionRequired(
  userId: any,
  from_date: any,
  to_date: any,
) {
  const url: any = `/v1/actionRequired/promotions/forme?event=promotions&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=${localStorage.getItem(
    'emplang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getDepartmentPromotions(eid: any, cid: any) {
  const url: any = `/v1/actionRequired/promotionHistory?empId=${eid}&companyId=${cid}&locale=${localStorage.getItem(
    'emplang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllAwards(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/awards/forme?userId=${userId}&event=award&from_date=${from_date}&to_date=${to_date}&locale=${localStorage.getItem(
    'emplang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAwardsHistory(uid: any, cid: any) {
  const url = `/v1/actionRequired/awardHistory?empId=${uid}&companyId=${cid}&locale=${localStorage.getItem(
    'applang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllTransfers(userId: any, from_date: any, to_date: any) {
  const url = `/v1/actionRequired/transfer/forme?event=transfer&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=${localStorage.getItem(
    'emplang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllWarning(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/warning/forme?event=warning&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=en`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllComplaint(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/complaints/forme?event=complaint&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllResignations(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/resignation/forme?event=resignation&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllTerminations(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/termination/forme?event=termination&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllClaims(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/claims/forme?event=claims&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllOvertime(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/overtime/forme?userId=${userId}&event=overtime&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllOffcycle(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/offcycle/forme?userId=${userId}&event=offcycle&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllRecurringPayment(
  userId: any,
  from_date: any,
  to_date: any,
) {
  const url = `v1/actionRequired/recurringPayment/forme?userId=${userId}&event=recurring%20payment&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllSetSalary(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/setSalary/forme?userId=${userId}&event=set%20salary&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllSalaryAdjustment(
  userId: any,
  from_date: any,
  to_date: any,
) {
  const url = `v1/actionRequired/salaryAdjustment/forme?userId=${userId}&event=salary%20adjustment&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllPayrollSettlement(userId: any) {
  const url = `v1/actionRequired/payrollSettlement/forme?userId=${userId}&event=payroll%20settlement&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllFnF(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/fnfSettlement/forme?userId=${userId}&event=fnf&from_date=${from_date}&to_date=${to_date}`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllEmpTickets(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/tickets/forme?event=ticket&userId=${userId}&from_date=${from_date}&to_date=${to_date}&locale=en`;

  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getWarningHistory(eid: any, dptId: any, cid: any) {
  const url = `v1/actionRequired/warningHistory?empId=${eid}&deptId=${dptId}&companyId=${cid}&locale=en`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getOffcycleHistory(eid: any, dptId: any, cid: any) {
  const url = `v1/actionRequired/offcycleHistory?empId=${eid}&deptId=${dptId}&companyId=${cid}&locale=en`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getClaimHistory(eid: any, cid: any) {
  const url = `v1/actionRequired/claimHistory?empId=${eid}&companyId=${cid}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getComplaintHistory(eid: any, dptId: any, cid: any) {
  const url = `v1/actionRequired/complaintHistory?empId=${eid}&deptId=${dptId}&companyId=${cid}&locale=en`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getOffCycleAttachment(id: any) {
  const url = `v1/offCycle/${id}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getLeaveTypes(cid: any) {
  const api = Core.getInstance().api();

  const data = await api.get(
    `/v1/config/typesById?locale=${localStorage.getItem('emplang')}`,
    {
      params: { id: 4, companyId: cid },
    },
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllLetterRequest(userId: any, from_date: any, to_date: any) {
  const url = `v1/actionRequired/letter-request/forme?userId=${userId}&event=letter request&from_date=${from_date}&to_date=${to_date}&locale=${localStorage.getItem(
    'emplang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
async function getAllCompOffRequest(userId: any, from_date: any, to_date: any) {
  const url = `/v2/actionRequired/compoff-request/forme?userId=${userId}&event=Comp Off&from_date=${from_date}&to_date=${to_date}&locale=${localStorage.getItem(
    'emplang',
  )}`;
  const api = Core.getInstance().api();

  const data = await api.get(url);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const actionRequiredService = {
  getActionRequiredDetail,
  getLeaveHistory,
  getLeaveInsight,
  getStepActions,
  userCanActOnStep,
  finalActionSubmitActionRequired,
  getAllPromotionsActionRequired,
  getDepartmentPromotions,
  getAllAwards,
  getAwardsHistory,
  getAllTransfers,
  getAllComplaint,
  getAllWarning,
  getWarningHistory,
  getAllResignations,
  getComplaintHistory,
  getAllTerminations,
  getAllClaims,
  getClaimHistory,
  getAllOvertime,
  getAllOffcycle,
  getOffcycleHistory,
  getAllRecurringPayment,
  getAllSetSalary,
  getAllSalaryAdjustment,
  getAllPayrollSettlement,
  getAllEmpTickets,
  getEmpTicketHistory,
  getAllFnF,
  getLeaveTypes,
  getAllLetterRequest,
  getAllCompOffRequest,
  getOffCycleAttachment,
  getLeaveEncashment
};
